import { writable } from 'svelte/store';

export const showAlertModal = writable(false);
export const showPostModal = writable(false);